// extracted by mini-css-extract-plugin
export default {"editForm":"CompanyEditProfile_editForm__L5HE4","editForm__section":"CompanyEditProfile_editForm__section__hHziI","title":"CompanyEditProfile_title__1yKHp"};